import { UserCheck } from 'lucide-react';
import { useTheme } from '../ThemeProvider';

interface FriendBadgeProps {
  /** Extra classes for spacing/positioning in the host layout. */
  className?: string;
  /**
   * Use the dark-theme colours regardless of the app theme.
   *
   * For hosts that are dark in both themes — the Highlights tiles, for one.
   * Following the app theme there renders the dark-green light-mode text onto a
   * near-black tile, which all but disappears.
   */
  forceDark?: boolean;
}

/**
 * Small "My Friend" pill shown on another user's account when they're a
 * confirmed (mutual) friend of the viewer. Reused across profile surfaces
 * (ProfileScreen, UserDetailModal, ProfilePreviewScreen) so the signifier looks
 * the same everywhere. Only render this when the viewer is actually friends with
 * the account — it is not gated internally.
 */
export function FriendBadge({ className = '', forceDark = false }: FriendBadgeProps) {
  const { theme } = useTheme();
  const isDark = forceDark || theme === 'dark';
  return (
    <span
      className={`inline-flex items-center justify-center whitespace-nowrap ${className}`}
      style={{
        gap: '3px',
        fontSize: '9px',
        fontWeight: 500,
        lineHeight: 1,
        padding: '3px 7px',
        borderRadius: '9999px',
        background: isDark ? 'rgba(46,204,113,0.20)' : 'rgba(46,204,113,0.15)',
        color: isDark ? '#5fd98a' : '#1e6b2c',
      }}
    >
      <UserCheck style={{ width: '9px', height: '9px', flexShrink: 0 }} />
      My Friend
    </span>
  );
}

export default FriendBadge;
